export default __webpack_public_path__ + "images/2337b4f845c62233156a0d4510f9addc.svg";